exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!style"), undefined);

// module
exports.push([module.id, ".UsefulQuestions__usefulQuestions___POIhF {\n  font-size: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"usefulQuestions": "UsefulQuestions__usefulQuestions___POIhF " + require("-!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!style").locals["text-brand"] + " " + require("-!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!style").locals["mt1"] + ""
};